


































import { Component } from 'vue-property-decorator';
import * as api from '@/api';
import { PaginationMixin } from '@/utils/mixin';
import EditGroupModal from './editGroupModal.vue';
@Component({
    components: {
        EditGroupModal
    }
})
export default class DxMemberGroup extends PaginationMixin {
    tableLoading: boolean = false;
    showModal: boolean = false;
    groupList: any[] = [];
    groupData: any = {};
    created() {
        this.getDxGroupList();
    }
    async getDxGroupList() {
        const res = await api.rgApi.getXmGroupList({
            rgId: this.rgId,
            cn: this.currentPage,
            sn: this.limit
        });
        const { data, code } = res;
        if (code === 200 && data) {
            this.groupList = data.rgXmGroupMemberList || [];
            this.total = data.tn;
        }
    }
    createGroup() {
        this.groupData = {};
        this.showModal = true;
    }
    onSuccess() {
        this.showModal = false;
        this.getDxGroupList();
    }
    handleChange(current: number, size: number) {
        this.limit = size;
        this.currentPage = current;
        this.getDxGroupList();
    }
    async deleteGroup(id, name) {
        const _this = this;
        this.$mtd
            .confirm({
                title: '确认删除成员组？',
                width: '433px',
                showCancelButton: true,
                type: 'warning',
                okButtonText: '确认',
                message: `确认删除成员组“${name}”吗？`,
                onOk: async () => {
                    try {
                        await api.rgApi.deleteXmGroup({
                            groupId: id,
                            rgId: this.rgId
                        });
                        this.$mtd.message({
                            message: '删除成功',
                            type: 'success'
                        });
                        await _this.getDxGroupList();
                    } catch (e) {
                        console.log(e);
                    }
                }
            })
            .catch(e => e);
    }

    get operations() {
        return [
            {
                label: '编辑',
                action: 'edit',
                click: (action: string, scope: any) => {
                    this.groupData = scope.row;
                    this.showModal = true;
                }
            },
            {
                label: '删除',
                action: 'delete',
                click: (action: string, scope: any) => {
                    this.deleteGroup(scope.row.groupId, scope.row.groupName);
                }
            }
        ];
    }
    get rgId() {
        return parseInt(this.$route.query.rgId as string, 10);
    }
}
